// 全局需用到的自定义数据

const constData = {
    // 收费项目权限枚举
    charge_auths: {
        ARM: '应收管理',
        EAR: '应收审批',
        CHA: '收费',
        OBD: '只收本部门',
        OAD: '实收审批',
        QUE: '查询',
        CAD: '只查本部门',
        OBB: '开票',
    },
    // 7.0后台程序返回状态码列表
    stateEnum: {
        SUCCESS: 200, // "处理成功",
        NOT_RESOURCE_POWER: 1001, // "没有资源权限",
        NOT_RESOURCE_MENU: 1002, // "没有菜单权限",
        NOT_LOGIN: 1003, // "尚未登录",
        NOT_REGISTER: 1004, // "尚未注册",
        NOT_LOGIN_TIMEOUT: 1005, // "登录已超时，请重新登录",
        NOT_TOKEN: 1006, // "页面Token无效",
        NOT_OPERATE_POWER: 1007, // "授权确认",
        PARAM_ERR: 2001, // "请求参数有误",
        PARAM_VERIFY_ERR: 2002, // "参数校验有误",
        PARAM_FORMAT_ERR: 2003, // "请求参数格式不正确",
        SYS_ERR: 3001, // "系统异常",
        SYS_OUT_USE_ERR: 3002, // "外部系统调用异常",
        SYS_CONF_ERR: 3003, // "系统配置错误",
        ERR: 4001, // "处理失败",
        NEXT_STEP: 5001, // "需要操作员确认操作",
    },
    // 【收费项目分类-收费项目】 拼接树的 顶级节点
    CHARGE_TYPE_ITEM_TOP_NODE: {
        children: [],
        code: '',
        enabled: true,
        id: -1,
        uniqueCode: '',
        leaf: false,
        visible: true,
        expanded: true,
        parentId: null,
        levels: -1,
        flag: 'root',
        name: "收费项目分类-收费项目",
        type: 1,
        typeName: "收费项目分类-收费项目",
    },
    // 【收费项目分类】 树的 顶级节点
    CHARGE_TYPE_TOP_NODE: {
        id: '',
        typeName: '收费项目分类',
        name: '收费项目分类',
        defaultTicketType: 0,
        applyFlow: 0,
        leaf: false,
        audittemplate: 0,
        remark: '',
        expanded: true,
        visible: true,
        parentId: null,
        levels: -1,
        flag: 'root',
        children: []
    },
    // 【交费方式分类】 树的 顶级节点
    CHARGE_PAY_TYPE_TOP_NODE: {
        id: '',
        name: '交费方式分类',
        typeName: '交费方式分类',
        remark: '',
        expanded: true,
        visible: true,
        parentId: null,
        levels: -1,
        flag: 'root',
        leaf: false,
        children: []
    },
    // 【部门-收费岗位】 树的 顶级节点   
    CHARGE_POST_TOP_NODE: {
        id: '',
        uniqueCode: '',
        name: '部门-收费岗位',
        remark: '',
        expanded: true,
        visible: true,
        parentId: null,
        levels: -1,
        flag: 'root',
        children: []
    },
    // 【票据类型分类】 树的顶级节点
    BILL_TYPE_CATEGRORY_TOP_NODE: {
        flag: 'root', // 用一个属性标识它为根节点
        levels: -1, // -1表示顶级节点，下一级为0，依次递增1
        leaf: false, // 为false代表有子节点，true为叶子（末级）节点
        children: [], // 这个属性必须要有，用来存储树返回的数据
        delete: false, // 表示不可删除
        enabled: false, // 表示未被使用
        ticketCategoryId: '', // nodeKey字段必须有，不然节点高亮有问题
        ticketCategoryName: '票据类型分类', // 这个key值必须和返回的树节点label字段一致
    },
    //  部门树的顶级节点 20190307
    PERSON_INFO_DEPARTMENT_TOP_NODE: {
        flag: 'root',
        levels: -1,
        leaf: false,
        children: [], // 这个属性必须要有，用来存储树返回的数据
        delete: false, // 表示不可删除
        enabled: false, // 表示未被使用
        id: '', // nodeKey字段必须有，不然节点高亮有问题
        name: '部门', // 这个key值必须和返回的树节点label字段一致
    },
    // 【字典管理】 树的顶级节点
    SYS_DICT_TOP_NODE: {
        uniqueCode: '',
        levels: -1,
        leaf: false,
        children: [],
        delete: false,
        enabled: false,
        code: '',
        name: '字典',

    },
    //系统参数岗位树
    SYS_POST_TOP_NODE: {
        uniqueCode: '',
        code: "",
        children: [],
        name: "部门-收费岗位",
        typeName: "部门-收费岗位",
        id: '',
        parentId: null,
        levels: -1,
        flag: 'root',
        type: 1,
        leaf: false,
        enabled: false
    },
    // 支付接口树
    SYS_PAY_TOP_NODE: {
        id: 0,
        code: "",
        parentCode: "",
        name: "支付接口",
        englishName: "pay-inteface",
        isUse: true,
        remark: null
    },
    // 人员类型
    perTypeList: [
        { code: 112, name: '学生' },
        { code: 111, name: '教工' },
        { code: 121, name: '临时人员' },
        { code: 201, name: '社会机构' },
    ],
    // 社会机构代码类型
    codeTypeList: [
        { code: 1, name: "组织机构代码" },
        { code: 2, name: "统一社会信用代码" }
    ],
    // 证件类型
    cardTypeList: [
        { code: 0, name: "身份证" },
        { code: 1, name: "学生证" },
        { code: 2, name: "港澳通行证" },
        { code: 3, name: "军官证" },
        { code: 4, name: "教师证" },
        { code: 5, name: "其他" }
    ],
    // 国籍
    nationalityList: [
        { code: 'ZH', name: '中国' },
        { code: 'USA', name: '美国' },
        { code: 'EN', name: '英国' },
        { code: 'GER', name: '德国' },
        { code: 'BAZ', name: '巴西' },
        { code: 'FRA', name: '法国' },
        { code: 'TAI', name: '泰国' },
        { code: 'RUS', name: '俄罗斯' },
    ],
    // 状态列表
    stateList: [
        { code: 'atSchool', name: '在校' },
        { code: 'leaveSchool', name: '离校' },
        { code: 'graduate', name: '毕业' },
        { code: 'dismiss', name: '开除' },
    ],
    // 年级列表
    gradeList: ['2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027'],
    // 主修专业列表
    majorList: ['机械工程与制造', '土木管理', '车辆工程', '应用数学', '高分子化学', '英语', '会计学', '计算机工程', '生命与环境'],
};

export default constData;